<template>
  <div class="Changesinfunds">
    <header class="flexAndCenter">
      <div>{{ $fanyi('商品金额变动明细') }}</div>
      <img src="../../../../../../assets/newImg//order/cancel.png"
        @click="$emit('cloneGoodsPriceUpdateDetailDialogVisible', false)" alt="" />
    </header>
    <div class="sectioncontent">
      <ul class="goodsPriceUpdateDetailTableHeader flexAndCenter">
        <li class="serialNumber">{{ $fanyi('序号') }}</li>
        <li class="beforeAdjustment marginRight20">
          {{ $fanyi('调整前数据') }}
        </li>
        <li class="beforeAdjustment marginRight20">
          {{ $fanyi('调整后数据') }}
        </li>
        <!-- <li class="outMoneyNumber marginRight20">{{ $fanyi('出入金编号') }}</li> -->

        <li class="outMoneyNumber marginRight20">{{ $fanyi('调整时间') }}</li>
        <li class="outMoneyNumber marginRight20">
          {{ $fanyi('调整具体明细') }}
        </li>
        <li class="beforeAdjustment marginRight20" style="width: 170px;">
          {{ $fanyi('金额') }}($)
        </li>
      </ul>
      <ul class="goodsPriceUpdateDetailTableFooter flexAndCenter" v-for="(item, index) in Changedetail" :key="index">
        <li class="serialNumber">{{ index + 1 }}</li>
        <li class="beforeAdjustment">
          <div v-for="(i, index) in item.detail" :key="index">
            ${{ $fanyi(i.key) }} : {{ i.val }}<span v-if="index != 0"></span>
          </div>
        </li>
        <li class="beforeAdjustment ">
          <div v-for="(i, index) in item.detail_edit" :key="index">
            ${{ $fanyi(i.key) }} : {{ i.val }}<span v-if="index != 0"></span>
          </div>
        </li>


        <li class="outMoneyNumber">{{ item.data_time
          }}</li>
        <li class="outMoneyNumber">
          <el-popover placement="bottom" trigger="hover">
            <div class="inputOption haveData">
              <p class="list" v-for="(eeitem, optionIndex) in item.adjust_detail" :key="optionIndex">
                {{ eeitem.index }}&nbsp;{{ eeitem }}
              </p>
            </div>
            <div slot="reference">
              <div class="inputOption haveData">
                <p class="list" v-for="(eeitem, optionIndex) in item.adjust_detail" :key="optionIndex">
                  {{ eeitem.index }}&nbsp;{{ eeitem }}
                </p>
              </div>
            </div>
          </el-popover>
        </li>
        <li class="outMoneyNumber" style="font-weight: 600;">
          {{ item.amount }}
        </li>
      </ul>
      <div class="Noadjustment" v-if="Changedetail.length == 0">{{ $fanyi('没有调整') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goodsPriceUpdateDetail',
  data() {
    return {
      Changedetail: [],
    }
  },
  created() {

  },
}
</script>

<style lang="scss" scoped>
.Changesinfunds {
  width: 1400px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 10px;
  padding-bottom: 10px;

  header {
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E2E2E2;
    padding: 0 20px;

    div {
      font-weight: 600;
      font-size: 18px;
      color: #222222;
      line-height: 28px;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }
}

.Noadjustment {
  width: 100%;
  height: 120px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #999999;
  text-align: center;
  line-height: 120px;
  border-bottom: 1px solid #e2e2e2;
}



.sectioncontent {
  width: 100%;
  padding: 20px;
  max-height: 600px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
  }

  .goodsPriceUpdateDetailTableHeader {
    height: 60px;
    background: #F6F6F6;
    border-radius: 6px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;

    li {
      font-weight: 500;
      font-size: 14px;
      color: #222222;
      line-height: 20px;
      text-align: center;
    }

    .serialNumber {
      flex: 0 0 60px;
    }

    .beforeAdjustment {
      flex: 0 0 180px;
    }

    .outMoneyNumber {
      flex: 0 0 200px;
    }
  }



  .goodsPriceUpdateDetailTableFooter {
    height: 120px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;

    li {
      text-align: center;
      font-size: 14px;
      color: #222;

      .inputOption {
        width: 100%;
        height: 120px;
        max-height: 100px;
        overflow-y: auto;

        &.haveData {
          background-color: white;
          border: 1px solid #ededed;
          color: #a7a7a7;
        }

        .placeHole {
          background-color: white;
          border: 1px solid #ededed;
          text-align: left;
          padding: 10px;
          line-height: 12px;
          position: relative;

          i {
            position: absolute;
            right: 5px;
            top: 11px;
            font-size: 12px;
            z-index: 0;
          }
        }

        .placeTiShi {
          color: #a7a7a7;
          font-size: 11px;
          word-break: break-all;
          text-align: left;
        }

        .list {
          text-align: left;
          padding-left: 10px;
        }
      }
    }

    .serialNumber {
      flex: 0 0 60px;
    }

    .beforeAdjustment {
      flex: 0 0 180px;
    }

    .outMoneyNumber {
      flex: 0 0 200px;
    }
  }

  .goodsPriceUpdateDetailTableFooter:hover {
    background-color: #f9f9f9;
    border-radius: 6px;
  }
}
</style>
